// extracted by mini-css-extract-plugin
module.exports = {"img--hidden":"_1tvcNSAsZ7FHZejte4q3tp"};